/**
 * Analytics Tracker Component
 * Sayfa değişikliklerinde otomatik tracking yapar
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../utils/analytics';

function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
        // Her sayfa değişikliğinde page view gönder
        const pageName = getPageName(location.pathname);
        trackPageView(location.pathname, pageName);
    }, [location.pathname]);

    return null; // Bu component görsel bir şey render etmez
}

// URL'den sayfa adı çıkar
function getPageName(pathname) {
    const routes = {
        '/': 'Ana Sayfa',
        '/dashboard': 'Dashboard',
        '/orders': 'Siparişler',
        '/products': 'Ürün Havuzu',
        '/auto-scrape': 'Otomatik Kazıma',
        '/catalog': 'Ürün Kataloğu',
        '/questions': 'Sorular',
        '/settings': 'Ayarlar',
        '/metrics': 'Metrikler',
        '/reports': 'Raporlar',
        '/accounting': 'Muhasebe',
        '/production': 'Üretim Raporu',
        '/subscription': 'Abonelik',
        '/account': 'Hesabım',
        '/team': 'Ekip',
        '/payment': 'Ödeme',
        '/register': 'Kayıt',
        '/tools': 'Araçlar',
        '/invoices': 'Faturalar',
        '/developers': 'Geliştiriciler',
        '/api-docs': 'API Dokümantasyonu'
    };

    // Exact match
    if (routes[pathname]) {
        return routes[pathname];
    }

    // Prefix match
    for (const [prefix, name] of Object.entries(routes)) {
        if (pathname.startsWith(prefix) && prefix !== '/') {
            return name;
        }
    }

    return 'OrderPanel';
}

export default AnalyticsTracker;
